<!--广告-->
<template>
  <div
    class="advertisement-contain"
    v-if="showAdvertise"
  >
    <van-image
      width="100%"
      height="100%"
      :fit="isPc?'contain':'cover'"
      :src="adUrl"
    />
    <div class="skip-contain">
      <div
        v-if="countTime <= 0"
        style="color:#FFF;font-size:0.16rem;"
        @click="skipAdv"
      >{{content.skip}}</div>
      <van-count-down
        v-else
        style="color:#FFF;font-size:0.16rem;"
        :time="countTime"
        :format="`ss ${content.ss}`"
        @finish="skipAdv"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      showAdvertise: false, // 是否展示开屏广告
      countTime: 0,
      adUrl: '',
      adTime: ''
    }
  },
  computed: {
    content() {
      return this.$store.state.content
    },
    ...mapState(['isPc'])
  },
  methods: {
    // 展示开屏广告
    showAdvertisement(data){
      this.adUrl = data.advUrl
      this.adTime = data.advTime
      this.countTime = Number(this.adTime) * 1000
      this.showAdvertise = true
    },
    // 跳过广告
    skipAdv() {
      this.countTime = 0
      this.showAdvertise = false
      this.$emit('countEnd')
    }
  }
}
</script>

<style scoped lang="less">
.advertisement-contain {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3001;
  background-color: #1D1D1D;
  .skip-contain {
    position: absolute;
    top: 0.4rem;
    right: 0.3rem;
    border-radius: 0.31rem;
    background-color: #737373;
    padding: 0.06rem 0.25rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>